<template>
     <div>
          <div class="card down_app mt-5">
              <div class="card-header down_app_header">
                   安卓下载
              </div>
              <div class="card-body p-0 down_app_content">
                   <div class="down_app_body">
                        <img class="down_app_img" src="../../static/images/jq.png" alt="" @mouseenter="showActive(1)" @mouseleave="showActive(0)">
                        <!-- <img v-show="active===1" class="down_app_img_jq" src="../../static/images/jq2.png" alt=""> -->
                   </div>
                <p class="p-3 font">
                    用手机浏览器左侧二维码扫描
                </p>
                <div class="down_app_x">
                    <img style="width:160px;height:160px;" src="../../static/images/rw.png" alt="">
                    <div style="width:400px;height:160px;display:flex;align-items:center;margin-left:80px;" class="text-center">
                        <p style="font-size:15px;">
                            用手机浏览器左侧二维码扫描，或使用手机浏览器访问
                            <a href="http://fxapp.hyey.cn/android/fwhyey.apk" style="font-weight:bold;" class="down_app_an">http://fxapp.hyey.cn/android/fwhyey.apk</a>
                            可直接下载app。
                        </p>
                    </div>
                </div>
              </div>
          </div>
     </div>
</template>
<script>
export default {
    data(){
        return {
            active:0
        }
    },
    methods:{
        showActive(index){
            this.active = index;
        }
    }
    
}
</script>
<style scoped>
     .down_app{
         width:1300px;
         margin:0 auto;
     }
     .down_app_header{
         font-size:25px;
     }
     .down_app_content{
         background-color:#f7f7f7;
     }
     .down_app_body{
         background-color:#fff;
     }
     .down_app_img{
         display: block;
         margin:0 auto;
         position:relative;
         bottom:0;
     }
     .down_app_img_jq{
        position: absolute;
        top:63px;
        left:544px;
     }
     .down_app_x{
         background-color:#fff;
         height:300px;
         display:flex;
         justify-content: center;
         align-items:center;
     }
     .font{
         font-size:25px;
     }
     .down_app_an{
         color:green;
     }
     .down_app_an:hover{
         color:aquamarine;
     }
</style>





// WEBPACK FOOTER //
// src/components/DownLoadApp.vue